import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './EmptySearchResults.styles';

type EmptySearchResultsProps = {
  title?: string;
  subtitle?: string;
};

export const EmptySearchResults = ({
  title,
  subtitle,
}: EmptySearchResultsProps = {}) => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <S.Title>{title ?? t('pages.ads.no_matching_ads_title')}</S.Title>
      <S.SubTitle>
        {subtitle ?? t('pages.ads.no_matching_ads_subtitle')}
      </S.SubTitle>
    </S.Box>
  );
};
